<div class="ranking ranking--square">

<div *ngIf="isTeam === false; else: teamimage" class="ranking__picture">
  <img
    [lazyLoad]="
    '//extranet.worldarchery.sport/ProfilePictures/?Id=' +
    id.toString()
  "
  />

</div>
<ng-template #teamimage>
  <div class="ranking__picture team">
  <img
        [lazyLoad]="
          '//extranet.worldarchery.sport/Flags/' +
          id.toString() +
          '.svg'
    "
  /></div>
</ng-template>
</div>
